"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dashboardTasksQueryStateDefaults = void 0;
const view_query_params_1 = require("../../../../common/view-query-params");
const dashboards_1 = require("../../../../store/catalogs/dashboards");
exports.dashboardTasksQueryStateDefaults = {
    [view_query_params_1.ViewQueryStateField.Filter]: dashboards_1.defaultDashboardsSliceState.priorityTasksTable.filter,
    [view_query_params_1.ViewQueryStateField.Sort]: dashboards_1.defaultDashboardsSliceState.priorityTasksTable.sort,
    [view_query_params_1.ViewQueryStateField.PageSize]: dashboards_1.defaultDashboardsSliceState.priorityTasksTable.pageSize,
};
